export const getFilePath = (fullName?: string): string => {
  return fullName ? `files/${encodeURIComponent(fullName)}` : '';
};
